import { Localization } from "@viamap/viamap2-common";

export function FileDropInformation() {

   return (
      <div className="FileDropInformation">
         <h1>{Localization.getText("Drop to load file")}</h1>
         <span>
            {Localization.getFormattedText("Hold {alt} on drop to access advanced import options", { alt: "ALT" })}
         </span>
      </div>
   )
}